import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectActiveQuizzes } from 'store/quiz/quizzesSelectors';
import IQuiz from 'models/Quiz';
// Components
import { Loader, Message } from 'components/Utilities';
import QuizzesListItem from './QuizzesListItem';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  sortedQuizzes: IQuiz[];
  onRequestSort: (key:string) => void;
  getClassNamesFor: (key:string) => void;
}

const QuizzesList:FC<Props> = ({ sortedQuizzes, onRequestSort, getClassNamesFor }) => {
  const { t } = useTranslation();

  const quizzes = useAppSelector(selectActiveQuizzes);

  if ( !quizzes ) return <Loader />;
  if ( !quizzes.length ) return <Message text={t('pages.activeQuizzes.noData')} />;
  return (
    <table className="responsive-table">
      <thead>
        <tr>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('quizName')}`}
            onClick={() => onRequestSort('quizName')}
          >{t('labels.name')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('organization')}`}
            onClick={() => onRequestSort('organization')}
          >{t('labels.organization')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('startsDate')}`}
            onClick={() => onRequestSort('startsDate')}
          >{t('labels.startDate')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('endsDate')}`}
            onClick={() => onRequestSort('endsDate')}
          >{t('labels.endDate')}</th>
          <th
            className="text-right"
          >{t('labels.actions')}</th>
        </tr>
      </thead>
      <tbody>
        {sortedQuizzes.map((quiz:IQuiz) => (
          <QuizzesListItem
            key={`group-item-${quiz._id}`}
            quiz={quiz}
          />
        ))}
      </tbody>
    </table>
  )
}

export default QuizzesList;
